export const ORGANIZATION_TEACHER = 'ORGANIZATION_TEACHER'
export const ORGANIZATION_PARENT = 'ORGANIZATION_PARENT'